import { FunctionComponent } from 'react';
import { Dialog, Table, TableRow, TableCell } from '../../../../tailwindcomponents';
import { Part } from '../../../../types/tasks';

type PartsDialogProps = {
  visible: boolean;
  taskName: string;
  parts: Array<Part>;
  onClose: () => void;
};

const PartsDialog: FunctionComponent<PartsDialogProps> = ({
  visible,
  taskName,
  parts,
  onClose,
}) => {
  const generatePartsTableBody = (row: Part, index: number) => {
    return (
      <TableRow key={index}>
        <TableCell></TableCell>
        <TableCell>{row.REQ}</TableCell>
        <TableCell>{row.PN}</TableCell>
        <TableCell>{row.PartDescription}</TableCell>
        <TableCell>{row.SN}</TableCell>
        <TableCell>{row.REQ_QT}</TableCell>
        <TableCell>{row.Status}</TableCell>
        <TableCell>{row.EST_ARRIVAL_DT}</TableCell>
      </TableRow>
    );
  };

  return (
    <Dialog
      visible={visible}
      max_width={"lg"}
      title={`Parts for  ${taskName}`}
      context={
        <div>
          <Table
            headers={["Req", "PN", "Description", "SN", "Qty", "Status", "ETA Date"]}
            rows={parts}
            generateBody={(row: Part, index: number) => generatePartsTableBody(row, index)}
          />
        </div>
      }
      onClose={() => onClose()}
      strict={false}
      show_options={false}
    />
  );
};

export default PartsDialog;
